import { PLAY_REPEAT, SOURCE_TYPE_VALUES } from "constant/panel";
import { AreaSource, PlayPanel, SourceType } from "type/panel/Panel.type";

const AREA_SOURCE_0: AreaSource = {
  area: {
    columnStart: 0,
    columnEnd: 2,
    rowStart: 0,
    rowEnd: 2,
  },
  source: [
    {
      content: `Потпун или савршен`,
      type: SOURCE_TYPE_VALUES.TEXT as SourceType,
      duration: 5,
    },
    {
      content: `догађај`,
      type: SOURCE_TYPE_VALUES.TEXT as SourceType,
      duration: 5,
    },
    {
      fileName: "exhibition_test_01.m4v",
      type: SOURCE_TYPE_VALUES.VIDEO as SourceType,
      duration: 3,
      start: 5,
      // repeat: PLAY_REPEAT.LOOP as PlayRepeat,
      // repeat: 2,
    },
    {
      fileName: "exhibition_test_02.m4v",
      type: SOURCE_TYPE_VALUES.VIDEO as SourceType as SourceType,
      duration: 5,
      repeat: 2,
    },
    {
      fileName: "exhibition_test_06.m4v",
      type: SOURCE_TYPE_VALUES.VIDEO as SourceType,
      duration: 5,
    },
    {
      fileName: "photo_test_04.jpg",
      type: SOURCE_TYPE_VALUES.PHOTO as SourceType,
      duration: 8,
    },
  ],
};

const AREA_SOURCE_1: AreaSource = {
  area: {
    columnStart: 2,
    columnEnd: 4,
    rowStart: 0,
    rowEnd: 2,
  },
  source: [
    {
      fileName: "photo_test_01.jpg",
      type: SOURCE_TYPE_VALUES.PHOTO as SourceType,
      duration: 5,
    },
    {
      content: `Потпун или савршен`,
      type: SOURCE_TYPE_VALUES.TEXT as SourceType,
      duration: 5,
    },
    {
      content: `догађај`,
      type: SOURCE_TYPE_VALUES.TEXT as SourceType,
      duration: 5,
    },
    {
      fileName: "photo_test_01.jpg",
      type: SOURCE_TYPE_VALUES.PHOTO as SourceType,
      duration: 55,
    },
    {
      fileName: "exhibition_test_01.m4v",
      type: SOURCE_TYPE_VALUES.VIDEO as SourceType,
      duration: 5,
    },
    {
      fileName: "exhibition_test_02.m4v",
      type: SOURCE_TYPE_VALUES.VIDEO as SourceType,
      duration: 5,
    },
    {
      fileName: "photo_test_01.jpg",
      type: SOURCE_TYPE_VALUES.PHOTO as SourceType,
      duration: 5,
    },
    {
      content: `Потпун или савршен догађај у тексту је онај догађај који се у смислу разрешења питања која поставља или потенцијалних отворених делова не може даље наставити нити разматрати а да то има квалитативног значаја. Ово наравно није апсолутна категорија и субјективног је типа.`,
      type: SOURCE_TYPE_VALUES.TEXT as SourceType,
      duration: 5,
    },
    {
      fileName: "photo_test_03.jpg",
      type: SOURCE_TYPE_VALUES.PHOTO as SourceType,
      duration: 8,
    },
  ],
};

export const PLAY_PANEL_EXHIBITION: PlayPanel = {
  areas: [AREA_SOURCE_0, AREA_SOURCE_1],
  repeat: PLAY_REPEAT.LOOP,
  playAudios: [],
};
